import React, { useState, useEffect } from 'react';
import { xml2json } from 'xml-js';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function XmlToJson() {
  const [xml, setXml] = useState('<root>\n  <item id="1">Value A</item>\n  <item id="2">Value B</item>\n</root>');
  const [json, setJson] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!xml.trim()) {
      setJson('');
      return;
    }

    try {
      const result = xml2json(xml, { compact: true, spaces: 2 });
      setJson(result);
    } catch (e) {
      setError(e.message);
      setJson('');
    }
  };

  const handleClear = () => {
    setXml('');
    setJson('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="XML to JSON Converter | Free Online Tool | UmbrellaCo"
        description="Convert XML strings and files into clean, formatted JSON. Free online tool that automatically parses attributes, namespaces, and nested XML data."
        keywords="xml to json, convert xml to json, xml to json converter online, parse xml, online json tools"
        url="/json-tools/xml-to-json"
        jsonLd={createSoftwareAppSchema(
          'XML to JSON Converter',
          'Convert XML strings and files into clean, formatted JSON.',
          'https://umbrellaco.in/json-tools/xml-to-json',
          ['XML Parsing', 'JSON Formatting', 'Attribute Handling']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
        title="XML to JSON Converter"
        description="Transform your XML documents and data structures into valid JSON format instantly."
        leftTitle="XML"
        rightTitle="JSON"
        leftLanguage="xml"
        rightLanguage="json"
        leftValue={xml}
        setLeftValue={setXml}
        rightValue={json}
        onConvert={handleConvert}
        onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default XmlToJson;